// Maximus Bot (iGotSolutions): the sidebar working label follows the open chat.
import { isRunWorking } from "./run-state.js";

/**
 * The bot list can still say "running" after the open chat's reply has
 * finished. Trust the open snapshot for that bot: clear Working once nothing
 * in this chat is still working. Another bot's row is left alone.
 */
export function settledRosterStatus(input: {
  listed: string;
  openBot: boolean;
  openRunStatuses: readonly string[];
}): string {
  if (!input.openBot) return input.listed;
  if (input.openRunStatuses.some((status) => isRunWorking(status))) {
    return input.openRunStatuses.find((status) => isRunWorking(status)) ?? input.listed;
  }
  return isRunWorking(input.listed) ? "idle" : input.listed;
}
